import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiDriverInterfaceService } from '../api-interface/api-driver-interface';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root',
})
export class JoinService {
    private userError = new BehaviorSubject<any>(null);
    private userData = new BehaviorSubject<any>(null);
    userSummaryDetails: any = null;

    constructor(
        private apiDriverInterfaceService: ApiDriverInterfaceService,
        private cookieService: CookieService
    ) {}

    getUserError() {
        return this.userError.asObservable();
    }

    setUserError(data: any) {
        this.userError.next(data);
    }

    getUserData() {
        return this.userData.asObservable();
    }

    setUserData(data: any) {
        this.userSummaryDetails = data;
        localStorage.setItem('status', data?.status);
        localStorage.setItem('texted_logs', data?.texted_logs);
        localStorage.setItem('activity_level', data?.activity_level);
        this.cookieService.set('tablet_id', data?.tablet);
        data?.driver_info?.lifetime_rides
            ? localStorage.setItem(
                  'lifetime_rides',
                  data?.driver_info?.lifetime_rides
              )
            : localStorage.setItem('lifetime_rides', '0');
        localStorage.setItem('allow_uber_connection', data?.allow_uber_connection);
        this.userData.next(data);
    }

    signup(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/sign_up/', payload);
    }

    login(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post('user/login/', payload);
    }

    getJoinDetails(): Observable<any> {
        return this.apiDriverInterfaceService.get('driver/join/', '');
    }

    getCities(zip: any): Observable<any> {
        return this.apiDriverInterfaceService.get(`driver/zipcode/${zip}`, '');
    }

    editJoinDetails(id: any, payload: any): Observable<any> {
        return this.apiDriverInterfaceService.patch(
            `driver/join/${id}/`,
            payload
        );
    }

    getPreferredLanguages(): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/preferred_language/',
            null
        );
    }

    getOTP(reason: any): Observable<any> {
        return this.apiDriverInterfaceService.get(
            `driver/otp/?otp_reason=${reason}`,
            null
        );
    }

    validateOTP(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/otp/', payload);
    }

    uploadImage(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.saveFormData(
            'driver/file-upload/',
            payload
        );
    }

    deleteImage(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.deleteFormData(
            'driver/file-upload/',
            payload
        );
    }

    forgotPassword(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/forgot_password/',
            payload
        );
    }

    resetPassword(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/reset_password/',
            payload
        );
    }

    savePaymentData(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/payment/', payload);
    }

    getFedExSuggestion(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/fedex_address_suggestion/',
            payload
        );
    }

    getMarkets(): Observable<any> {
        return this.apiDriverInterfaceService.get('driver/markets/', null);
    }

    saveReapplyDetails(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/reapply/', payload);
    }

    updateDriverStatus(): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/status-change/',
            null
        );
    }

    resetPhone(): Observable<any> {
        return this.apiDriverInterfaceService.get('driver/verification-request/', null);
    }

    submitPhoneReset(payload: { old_phone_number: string; new_phone_number: string; confirm_phone_number: string }): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/verification-request/', payload);
    }

    verifyPhoneUpdateOtp(payload: { otp: string }): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/verification-request/verify-otp/', payload);
    }

    resendPhoneUpdateOtp(): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/verification-request/resend-otp/', null);
    }
}
